<template>
    <div style="position: relative; min-height: 45px; width: 100%;">
        <div class="py-0" style="border-bottom: 1px solid #EDEDF2">
            <div @click="clickCustomer(customer)"
                :disabled="customer._id.sender_id===customer_selected"
                :class="`${customer._id.sender_id===customer_selected? 'customer_activate': ''}`"
                class="customer-container"
            >
                <div style="padding: 12px">
                    <v-badge :color="colorBadge(customer)" overlap left value="0px" origin="0px">
                        <span v-if="isNeedSupport(customer)" slot="badge"></span>
                        <img :src="'/assets/icons/platform/'+customer['sender_channel']+'.svg'" :alt="customer['sender_channel']" style="width: 46px; border-radius: 100%">
                    </v-badge>
                </div>
                <div style="padding: 12px 12px 12px 0">
                    <v-layout align-center class="ma-0 pa-0">
                        <v-tooltip top>
                            <div slot="activator">
                                <div class="customer_name" :class="{unseen: !customer.seen}">
                                {{parseSenderName(customer)}}
                                </div>
                                <div class="req-box" v-if="isNeedSupport(customer) && !customer.supporter">
                                    {{$t('request')|capitalize}}
                                </div>
                            </div>
                            <span>{{parseSenderName(customer)}}</span>
                        </v-tooltip>
                        <v-spacer></v-spacer>
                        <div style="color: #888A9A">
                            {{(customer.last_user_interactive_time ? customer.last_user_interactive_time : customer.updated_time) | moment("calendar")}}
                        </div>
                        <div v-if="is_done">
                            <v-icon size="16" color="green">mdi-check-circle</v-icon>
                        </div>
                    </v-layout>
                    <v-layout>
                        <div :class="customer.seen ? '' : 'unseen'" class="text-ellipsis">
                            {{parseLastMessage(customer)}}
                        </div>
                        <v-spacer></v-spacer>
                        <img v-if="customer.bot_answer_last" src="/icon/bot.svg" alt="" class="px-1">
                        <img v-if="customer.block_status" src="/icon/lock/lock-gray.svg" alt="" class="px-1">
                        <!--<img src="/icon/warning_2.svg" alt="" class="ml-1">-->
                    </v-layout>
                    <div class="supporter">
                        <template v-if="customer.supporter">
                            <div class="supporter-box">{{$t('supporting') | capitalize}}</div>
                            {{parseSupporter(customer.supporter)}}
                        </template>
                        <template v-else-if="customer.last_supporter">
                            <div class="supported-box">{{$t('supported') | capitalize}}</div>
                            {{parseSupporter(customer.last_supporter)}}
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BotService from "@/services/bot.service";
import {mapActions, mapMutations, mapState} from "vuex";

const moment = require('moment');

    export default {
        name: "CustomerBox",
        props: {
            customer: {
                type: Object,
            },
            empty_message: {
                type: String,
                default: ''
            },
            is_done: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                customer_selected: ''
            }
        },
        computed: {
           ...mapState(['agentConfig']),
        },
        methods: {
            ...mapActions('ticket', ['getCountOpening']),
            ...mapMutations('sideBox', ['hideAllSideBox']),
            clickCustomer(customer){
                if (customer._id.sender_id !== this.customer_selected) {
                    let botCode = customer._id.app_code;
                    let senderId = customer._id.sender_id;
                    this.getCountOpening({botCode, senderId});
                    this.hideAllSideBox();
                    this.$router.push(`/bot/${botCode}/s/${senderId}`);
                }
            },
            isNeedSupport(customer){
                return customer['need_support'] === true
            },
            parseLastMessage(customer){
                let last_message = customer.last_message,
                    last_user_chatlog = customer.last_user_chatlog,
                    last_supporter_chatlog = customer.last_supporter_chatlog,
                    last_bot_chatlog = customer.last_bot_chatlog;
                let source;
                let last_message_time = (!!last_user_chatlog && !!last_user_chatlog.created_time) ? moment(last_user_chatlog.created_time).valueOf() : 0;

                if (!!last_user_chatlog && !!last_user_chatlog.message) {
                    last_message = last_user_chatlog.message;
                    source = "sender";
                }
                if (this.agentConfig.show_last_agent_message === "1") {
                    let last_supporter_chatlog_time = (!!last_supporter_chatlog && !!last_supporter_chatlog.created_time) ? moment(last_supporter_chatlog.created_time).valueOf() : 0;
                    if (last_supporter_chatlog_time > 0 && last_supporter_chatlog_time > last_message_time) {
                        last_message = last_supporter_chatlog.message;
                        source = "supporter";
                        last_message_time = last_supporter_chatlog_time;
                    }
                }
                if (this.agentConfig.show_last_bot_message === "1") {
                    let last_bot_chatlog_time = (!!last_bot_chatlog && !!last_bot_chatlog.created_time) ? moment(last_bot_chatlog.created_time).valueOf() : 0;
                    if (last_bot_chatlog_time > 0 && last_bot_chatlog_time > last_message_time) {
                        last_message = last_bot_chatlog.message;
                        source = "bot";
                        last_message_time = last_bot_chatlog_time;
                    }
                }

                last_message = this.parseLastMessageString(last_message);
                if (source === "supporter" && !!last_supporter_chatlog.created_time) {
                    last_message = `[${moment(last_supporter_chatlog.created_time).calendar()}] ` + last_message;
                }
                return last_message;
            },
            parseLastMessageString(last_message) {
                let return_message = '';
                try {
                    let message = JSON.parse(last_message);
                    switch (message.type) {
                        case 'text':
                            return_message = message.content.text;
                            break;
                        case 'image':
                            return_message = '[Bot sends an image]';
                            break;
                        case 'carousel':
                            return_message = '[Bot sends a carousel]';
                            break;
                        case 'quick_reply':
                            return_message = message.content.text;
                            break;
                        case 'payload':
                            if (message.content.text === 'get_started') {
                                return_message = '[User starts the conversation]';
                            } else {
                                let _message = message.content.text.split('#');
                                return_message = _message.length === 3 ? _message[2] : _message[0]
                            }
                            break;
                        case 'request_human_support':
                            return_message = '[User requests support from admins]';
                            break;
                        case 'typing':
                            return_message = '[Bot send typing message]';
                            break;
                        case 'file':
                            var jContent = {};
                            if (typeof (message.content) === 'string') {
                                jContent = JSON.parse(message.content);
                            } else {
                                jContent = message.content;
                            }
                            return_message = jContent.file_name ? jContent.file_name : jContent.url;
                            break;
                        case 'zalo_list_template':
                            return_message = '[Bot send list template message]';
                            break;
                        case 'sticker':
                            return_message = '[User send sticker]'
                            break;
                        default:
                            break;
                    }
                } catch (e) {
                    return return_message;
                }
                return return_message;
            },
            parseSupporter(supporter){
                let supporter_res = '';
                try {
                    supporter_res = (typeof supporter === 'object' && supporter !== undefined) ? supporter.email : JSON.parse(supporter).email
                } catch (e) {
                    return supporter_res;
                }
                return supporter_res;
            },
            parseSenderName(customer){
                return customer.sender_name?customer.sender_name:customer._id.sender_id;
            },
            colorBadge(customer){
                return customer.supporter?'#F7B92F':'red'
            },
        },
        mounted(){
            let sender_id = this.$route.params['senderId'];
            if (sender_id) {
                this.customer_selected = sender_id;
            }
        },
        watch: {
            $route: {
                handler(){
                    this.customer_selected = this.$route.params.senderId;
                }
            }
        }
    }
</script>

<style scoped lang="scss" src="../style/customer-box.scss">
</style>
